import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Strategy = ({ listStrategy }) => {
    return (
        <div className="otpBank-strategy">
            <FullWrapper caseName="otpBank-strategyCase">
                <div className="otpBank-strategyWrapper">
                    <div className="otpBank-strategyInner">
                        <div className="otpBank-strategyLeft">
                            <div>
                                Для решения выявленных технических проблем по&nbsp;сайту предложили
                                поэтапную стратегию по&nbsp;оптимизации и&nbsp;seo-продвижению.
                            </div>
                            <div>
                                Начали с&nbsp;точечной проработки мета-тегов и&nbsp;заголовков
                                h1&nbsp;на посадочных страницах. Также предложили решения
                                по&nbsp;перелинковки на&nbsp;внутренних страницах сайта. Подготовили
                                технические задания по&nbsp;исправлению 404 ошибок и&nbsp;настройки
                                301&nbsp;редиректов. В&nbsp;рамках еженедельных спринтов
                                осуществляли контроль их&nbsp;внедрения.
                            </div>
                            <div>
                                С&nbsp;учетом приоритетов клиента по&nbsp;развитию
                                и&nbsp;рекомендациям экспертов нашей команды определяли, куда
                                направить основной вектор продвижения, учитывали бизнес-интересы
                                и&nbsp;совмещали их&nbsp;с&nbsp;инструментами SEO. Сфокусировались
                                на&nbsp;приоритетных разделах &laquo;Кредиты&raquo;, &laquo;Малый
                                бизнес&raquo;, &laquo;Вклады&raquo;.
                            </div>
                        </div>
                        <div className="otpBank-strategyRight">
                            Подготовили технические задания по&nbsp;исправлению 404 ошибок
                            и&nbsp;настройки 301&nbsp;редиректов.
                        </div>
                    </div>

                    <div className="otpBank-strategyText">
                        С&nbsp;октября 2021 по&nbsp;декабрь 2022 года небрендовый трафик вырос
                        в&nbsp;разделах:
                    </div>

                    <div className="otpBank-strategyStatistic">
                        {listStrategy.map((item, index) => (
                            <div className="otpBank-strategyStatisticItem" key={index}>
                                <div className="otpBank-strategyStatisticTop">
                                    <div className="otpBank-strategyStatisticText">{item.text}</div>
                                    <img
                                        src={item.icon}
                                        alt="metrics"
                                        className="otpBank-strategyStatisticIcon"
                                    />
                                </div>
                                <div className="otpBank-strategyStatisticNumber">{item.number}</div>
                            </div>
                        ))}
                    </div>

                    <div className="otpBank-strategyDescription">
                        В&nbsp;выдаче поисковых систем присутствует большое количество финансовых
                        агрегаторов. Самые крупные банки в&nbsp;России могут наращивать большие
                        объемы ссылочной массы естественным путем. Для сайта otpbank.ru сделали
                        акцент на&nbsp;узкоспециализированные ключи: кредит на&nbsp;200&nbsp;000,
                        кредит на&nbsp;5&nbsp;лет, кредитная карта для студентов
                        и&nbsp;т.&thinsp;д.&nbsp;и&nbsp;региональные ключи: кредит
                        в&nbsp;Краснодаре, кредит в&nbsp;Самаре.
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Strategy;
